
import axiosClient from "./axiosClient";

const serviceUrl = '/qlttbhyt-service/thanh-toan';

const insuranceService = {

  checkInsurance: async (params) => {
    const url = serviceUrl + `/tra-cuu-api-bao-hiem-y-te`
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  postInsuranceInfo: async (params) => {
    const url = serviceUrl + `/bao-hiem-y-te`
    const response = await axiosClient.post(url, params );
    return response;
  }
}

export default insuranceService;